import { Search } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import {
  ChangeEvent,
  KeyboardEvent,
  ReactElement,
  useEffect,
  useState,
} from "react";
import { useTranslation } from "react-i18next";

import { KeyboardKeys } from "@ryde/shared";

interface IInputSearchProps {
  label?: string;
  onSearchApply: (searchValue: string) => void;
  onSearchType?: (searchValue: string) => void;
  value?: string;
}

export const InputSearch = ({
  label,
  onSearchApply,
  onSearchType,
  value,
}: IInputSearchProps): ReactElement => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState(value ?? "");

  useEffect(() => {
    if (value === searchValue || value === undefined) {
      return;
    }

    setSearchValue(value);
  }, [searchValue, setSearchValue, value]);

  const onChange = (event: ChangeEvent<HTMLInputElement>): void => {
    onSearchType?.(event.target.value);
  };

  const onKeyDown = (event: KeyboardEvent): void => {
    if (event.key !== KeyboardKeys.ENTER) {
      return;
    }

    searchApply();
  };

  const searchApply = (): void => {
    onSearchApply(searchValue);
  };

  return (
    <TextField
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        },
      }}
      placeholder={label ?? t("general.SEARCH")}
      variant="standard"
      value={searchValue}
      onChange={onChange}
      onKeyDown={onKeyDown}
    />
  );
};
